import React from 'react'
import { Accordion, cn } from 'ui'

export const PricingTable = React.forwardRef<
  HTMLDivElement,
  React.HTMLAttributes<HTMLDivElement>
>(({ className, children, ...props }, ref) => {
  return (
    <div
      className={cn('w-full flex justify-center items-center', className)}
      {...props}
      ref={ref}
    >
      <div className='max-w-7xl w-full items-center flex justify-center px-12'>
        <div
          className={cn(
            'w-full flex justify-center md:items-start',
            'flex-col space-y-5 md:flex-row md:space-x-5 md:space-y-0'
          )}
        >
          {children}
        </div>
      </div>
    </div>
  )
})
